import { Column } from 'devextreme-react/data-grid';
import React, { useMemo } from 'react';

const isValidWasteData = (array) => Array.isArray(array) && array.length > 0;
const wasteReducer = (a, v) => ({ ...a, [v.matnrCompText]: v });
const sapWasteReducer = (a, v) => ({ ...a, [`${v.matnrCompText}, SAP`]: v });

/** Хук возвращает колонку для отходов невесовых единиц измерения
 * @param dataSource data[] Данные для грида
 * @include allWastes[] Содержит данные отходов
 * @include allSapWastes[] Содержит данные отходов SAP, опционально
 * @returns [dataSource, renderer]
 * добавил поля readyWeightForSumNetto и readyWeightForSumOff для подсчёта суммы веса по уникальным
 * ГП для вкладки FinishedProductConfirmation
 */
const useWasteColumns = (dataSource) => {
  /** Форматируем данные для использования в таблице */
  const wasteFormatData = useMemo(
    () => {
      const uniqueReadyPieceNumId = [];
      const dataSourceModified = [];
      if (dataSource.length) {
        dataSource.forEach((ds) => {
          if (!uniqueReadyPieceNumId.includes(ds.readyPieceNumId)) {
            uniqueReadyPieceNumId.push(ds.readyPieceNumId);
            dataSourceModified.push({
              ...ds,
              readyWeightForSumNetto: ds.readyWeightNetto,
              readyWeightForSumOff: ds.readyWeightOff,
              quantityRemainForSum: ds.quantityRemain && ds.quantity
            });
          } else {
            dataSourceModified.push({
              ...ds,
              readyWeightForSumNetto: 0,
              readyWeightForSumOff: 0,
              quantityRemainForSum: ds.quantityRemain && ds.quantity
            });
          }
        });
      }
      return dataSourceModified.map((d) => ({
        ...d,
        allWastes: isValidWasteData(d.allWastes)
          ? d.allWastes.reduce(wasteReducer, {})
          : [],
        allSapSemiWastes: isValidWasteData(d.allSapSemiWastes)
          ? d.allSapSemiWastes.reduce(sapWasteReducer, {})
          : []
      }));
    },
    [dataSource]
  );

  /** Уникальные значения для колонок отходов */
  const wasteData = useMemo(() => {
    if (!dataSource || !dataSource.length) return [];

    const wastes = dataSource.map((d) => d.allWastes).flat();
    const sapWastes = dataSource.map((d) => d.allSapSemiWastes).flat();
    const mapper = wastes.map((item) => item.matnrCompText);
    const mapperSap = sapWastes.map((item) => `${item.matnrCompText}, SAP`);

    return [...new Set([...mapper, ...mapperSap]).values()];
  }, [dataSource]);

  /** Рендерер для колонки отходов */
  const renderItem = (item) => {
    const dataKey = (item && item.includes('SAP')) ? 'allSapSemiWastes' : 'allWastes';
    return (
      <Column caption={item} key={item}>
        <Column
          caption={'Кол-во'}
          dataField={`${dataKey}.${item}.weightOff`}
          dataType="number"
        />
        <Column
          caption={'ЕИ'}
          dataField={`${dataKey}.${item}.unitOfWaste`}
          dataType="string"
        />
      </Column>
    );
  };
  /** Рендерер масива колонок отходов */
  const renderer = wasteData.map(renderItem);

  return [wasteFormatData, renderer];
};

export default useWasteColumns;
